import { app } from '@/utils'
import env from '@/utils/clientEnv'
import { setCookie, getCookie } from '@/utils/common'
let _res = null

const statusBarHeight = {
  install(Vue, options = {}) {
    Vue.directive('statusBarHeight', {
      inserted: function (el, binding) {
        let pageWidth = env.isPadVivoApp || env.isFoldableApp ? 400 : window.screen.width
        _res = +(_res || getCookie('app_status_bar_height')) // 缓存避免切换页面计算时，导航跳动
        if (_res) {
          if (env.isIOSVivoApp) {
            binding.value && (el.style[binding.value] = _res + 'px')
            return
          }
          binding.value && (el.style[binding.value] = ((((_res + 24) * pageWidth) / (100 * 720)) * 150) / 100 + 'rem')
        } else if (binding.arg || binding.arg === undefined) {
          app.getTitleBarHeight({
            type: 'statusBarHeight',
            success: res => {
              // 用于缓存
              setCookie('app_status_bar_height', res)
              if (env.isIOSVivoApp) {
                // IOS app内安全区距离为px距离
                binding.value && (el.style[binding.value] = res + 'px')
                return
              }
              // + 10  为了多空一些距离，避免太靠近
              binding.value &&
                (el.style[binding.value] = ((((res + 24) * pageWidth) / (100 * 720)) * 150) / 100 + 'rem')
            }
          })
        }
      }
    })
  }
}
export default statusBarHeight
